import {
  ANALYTICS_FLUSH_DATA,
  ANALYTICS_SET_RISK,
  ANALYTICS_SET_PLAN,
  ANALYTICS_PUSH_EVENT,
  ANALYTICS_ADD_ADDITIONAL_DATA,
} from './analytics.action-types';

const INITIAL_STATE = {
  pageAdditionalData: {},
};

const analyticsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ANALYTICS_FLUSH_DATA:
      return INITIAL_STATE;

    case ANALYTICS_SET_RISK:
      return {
        ...state,
        pageAdditionalData: { ...state.pageAdditionalData, ...action.payload },
      };
    case ANALYTICS_SET_PLAN:
      return {
        ...state,
        pageAdditionalData: { ...state.pageAdditionalData, ...action.payload },
      };
    case ANALYTICS_ADD_ADDITIONAL_DATA:
      return {
        ...state,
        pageAdditionalData: { ...state.pageAdditionalData, ...action.payload },
      };
    case ANALYTICS_PUSH_EVENT:
      return state;
    default:
      return state;
  }
};

export default analyticsReducer;